import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { NativeSubscriptionOptions, SubscriptionLegalCopy } from '@/components/NativeSubscriptionOptions';

/**
 * Full-screen native IAP entry.
 */
export function SubscriptionGate({ firebaseUid, onUnlocked }) {
  return (
    <div className="min-h-dvh bg-app flex items-center justify-center px-6 py-10">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-[2rem] border border-theme-secondary bg-theme-light p-6 shadow-ambient"
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="h-11 w-11 rounded-2xl bg-theme-primary flex items-center justify-center">
            <Sparkles size={20} className="text-primary" />
          </div>
          <div>
            <p className="font-heading text-lg text-primary">RE-BUILD-ME-PRO</p>
            <p className="font-body text-xs text-secondary">Subscription required</p>
          </div>
        </div>

        <p className="font-body text-sm text-secondary leading-relaxed mb-4">
          Choose the billed amount below. Any introductory offer appears on the store confirmation sheet after the recurring price.
        </p>
        <NativeSubscriptionOptions firebaseUid={firebaseUid} onActivated={onUnlocked} />
        <SubscriptionLegalCopy className="mt-4" />
      </motion.div>
    </div>
  );
}
